import { SVGAttributes } from 'react';

type Props = SVGAttributes<SVGElement>;

export function IconDot(props: Props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
            <rect x="8" y="8" width="8" height="8" rx="4" />
        </svg>
    );
}
